import React, { useEffect, useRef, useState } from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useFormik } from 'formik'
import { userProfileDetails, updateUserProfile } from './../../../services/profile.services'
import CustomError from '../../../../../utils/customError'
import Swal from 'sweetalert2'
import { SWAL_SETTINGS, INPUT_MAX_25, PHONE_NO_LENGTH, TEXTAREA_MAX_LENGTH, LOADER_TIMEOUT_TIME , ROLE} from '../../../../../utils/Constants'
import { handleServerValidations, DT, globalLoader , setLocalKey , getLocalKey } from '../../../../../utils/commonfunction'
import * as Yup from 'yup'
import PhoneInput from '../../../../../utils/PhoneInput'
import Skeleton from 'react-loading-skeleton'


export default function RestMyProfile() {
    const { t } = useTranslation()
    const [defaultData, setDefaultData] = useState({});
    const fileSelectInput = useRef();
    const [loader, setLoader] = useState(true);
    const [addSubmissionLoader, setAddSubmissionLoader] = useState(false);
    const SUPPORTED_FORMATS = ["image/jpg", "image/jpeg", "image/png", "image/gif", "image/webp"];

    const validateSchema = Yup.object().shape({
        first_name: Yup.string().trim().max(INPUT_MAX_25, "restaurant.profile.max_length_error").required("restaurant.profile.label_first_name_error"),
        last_name: Yup.string().trim().max(INPUT_MAX_25, "restaurant.profile.max_length_error").required("restaurant.profile.label_last_name_error"),
        email: Yup.string()
            .trim()
            .email("restaurant.profile.label_email_invalid_format_error")
            // .test('no-uppercase', "restaurant.profile.label_email_uppercase_error", function (value) {
            //     if (value) {
            //         return !/[A-Z]/.test(value);
            //     }
            //     return true;
            // })
            .required("restaurant.profile.label_email_required_error"),
        phone_number: Yup.string()
            .test('phone_required', 'restaurant.profile.label_phone_number_required_error', (value) => {
                const phoneNumber = (value.split(" "))[1];
                return phoneNumber && phoneNumber.length;
            }
            )
            .test('phone_digit_error', 'restaurant.profile.label_phone_number_digits_error', (value) => {
                const phoneNumber = (value.split(" "))[1];
                return phoneNumber && /^\d+$/.test(phoneNumber);
            }
            )
            .test('phone_min_length', 'restaurant.profile.label_phone_number_min_length_error', (value) => {
                const phoneNumber = (value.split(" "))[1];
                return phoneNumber && phoneNumber.length >= PHONE_NO_LENGTH.min;
            }
            )
            .test('phone_max_length', 'restaurant.profile.label_phone_number_max_length_error', (value) => {
                const phoneNumber = (value.split(" "))[1];
                return phoneNumber && phoneNumber.length <= PHONE_NO_LENGTH.max;
            }
            )
        ,
        // address: Yup.string().max(TEXTAREA_MAX_LENGTH, DT("restaurant.profile.validation_max_input_characters", [TEXTAREA_MAX_LENGTH])).trim().required("restaurant.profile.label_location_error"),
        // profile_image: Yup.string().required("restaurant.profile.label_profile_image_error"),
        profile_image: Yup.mixed()
            .nullable()
            .test(
                'fileOrUrl',
                'admin.cafes.supported_file_error',
                value => {
                    if (!value) return true;
                    if (typeof value === 'string') return /^(http|https):\/\/[^\s$.?#].[^\s]*$/gm.test(value);
                    return ['image/jpg', 'image/jpeg', 'image/png', 'image/webp', 'image/gif'].includes(value.type);
                }
            )
            .test(
                'fileSize',
                'admin.cafes.image_max_size_error',
                value => {
                    if (!value || typeof value === 'string') return true;
                    return value.size <= 1.5 * 1024 * 1024;
                }
            ),
    })

    useEffect(() => {
        userProfileDetails().then((response) => {
            setTimeout(() => { setLoader(false); }, LOADER_TIMEOUT_TIME);
            setDefaultData(response && response.data ? response?.data : {});
            console.log('set data into local storage', response.data);
            setLocalKey(ROLE.RESTAURANT, JSON.stringify(response.data));
        }).catch((error) => {
            setTimeout(() => { setLoader(false); }, LOADER_TIMEOUT_TIME);
            Swal.fire({
                icon: "error",
                text: handleServerValidations(error),
                ...SWAL_SETTINGS,
            });
        })
    }, []);

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            email: defaultData && defaultData.email || "",
            first_name: defaultData && defaultData.first_name || "",
            last_name: defaultData && defaultData.last_name || "",
            // address: defaultData && defaultData.address || "",
            phone_number: defaultData && defaultData.phone_number || "",
            // phone_code: defaultData && defaultData.phone_code || "",
            profile_image: defaultData && defaultData.profile_image || "",
        },
        validationSchema: validateSchema,
        onSubmit: (values, { setSubmitting, resetForm }) => {
            // globalLoader(true);
            let formData = new FormData();
            formData.append("email", values.email);
            formData.append("first_name", values.first_name);
            formData.append("last_name", values.last_name);
            // formData.append("address", values.address);
            formData.append("phone_number", values.phone_number);
            formData.append("profile_image", values.profile_image);
            setAddSubmissionLoader(true);

            updateUserProfile(formData)
                .then((response) => {
                    setAddSubmissionLoader(false);
                    globalLoader(false)
                    setSubmitting(false);
                    // let userData = getLocalKey(ROLE.RESTAURANT) ? JSON.parse(getLocalKey(ROLE.RESTAURANT)) : {};
                    let userData = getLocalKey(ROLE.RESTAURANT);

                    console.log('data received', userData);

                    // Parse if it’s a string
                    if (typeof userData === "string") {
                        try {
                            userData = JSON.parse(userData);
                        } catch (e) {
                            console.error("Invalid JSON in local storage:", e);
                            userData = {};
                        }
                    }

                    if (userData) {
                        console.log(response.data.profile_image)
                        userData.profile_image = response.data && response.data.profile_image ? response.data.profile_image : userData.profile_image;
                        userData.first_name = response.data && response.data.first_name ? response.data.first_name : userData.first_name;
                        userData.last_name = response.data && response.data.last_name ? response.data.last_name : userData.last_name;
                        console.log('set updated data');
                        setLocalKey(ROLE.RESTAURANT, JSON.stringify(userData));
                        // 👇 Dispatch a custom event
                        window.dispatchEvent(new Event("userDataUpdated"));
                    }
                    if (response.success) {
                        Swal.fire({
                            icon: "success",
                            text: response.message,
                            ...SWAL_SETTINGS,
                        });
                    } else {
                        Swal.fire({
                            icon: "error",
                            text: handleServerValidations(response),
                            ...SWAL_SETTINGS,
                        });
                    }
                })
                .catch((error) => {
                    setAddSubmissionLoader(false);
                    globalLoader(false)
                    Swal.fire({
                        icon: "error",
                        text: handleServerValidations(error),
                        ...SWAL_SETTINGS,
                    });
                    console.log("error===>", error)
                })
        }
    });

    const handleFileSelection = (event) => {
        if (event.target.files.length) {
            formik.setFieldValue("profile_image", event.target.files[0]);
        }
    };

    const handleFilePreview = (file) => {
        if (typeof file === "string") {
            return file;
        } else {
            return URL.createObjectURL(file);
        }
    };


    return (
        <main id='main-content'>
            <div className='inner-container'>
                <h1 className='mb-4'>{t("My Profile")}</h1>
               
                <div className='card'>
                    <div className='card-body'>
                        {loader ?
                            <div className='w-100'>
                                <Skeleton circle={true} style={{ width: "96px", height: "96px" }} />
                                <Skeleton className='mt-4' style={{ height: "30px" }} />
                                <Skeleton className='mt-4' style={{ height: "30px" }} />
                                <Skeleton className='mt-4' style={{ height: "30px" }} />
                            </div>
                            :
                            <form onSubmit={formik.handleSubmit}>
                                <div className='profile-photo-upload mb-3'>
                                    <div className='avatar avatar-xl'>
                                        <img alt='profile-img' src={handleFilePreview(formik?.values?.profile_image)} />
                                    </div>
                                    <button className='cp e_none' type='button' onClick={() => { fileSelectInput?.current?.click() }}>
                                        <input
                                            ref={fileSelectInput}
                                            id="profile_image"
                                            name="profile_image"
                                            accept="image/*"
                                            type='file'
                                            onChange={handleFileSelection}
                                        />
                                        <i className='ti ti-upload'></i>
                                    </button>
                                </div>
                                    <CustomError name="profile_image" form={formik} className="text-danger my-3" /> 
                                <div className='row'>
                                    <div className='col-md-6'>
                                        <div className="mb-3">
                                            <label htmlFor='first_name' className="form-label">{t("restaurant.profile.label_first_name")}<span>*</span></label>
                                            <input
                                                type="text"
                                                id='first_name'
                                                className="form-control"
                                                placeholder={t("restaurant.profile.placeholder_first_name")}
                                                name="first_name"
                                                value={formik.values.first_name}
                                                onChange={formik.handleChange}
                                                onBlur={formik.onBlur}
                                            />
                                            <CustomError name="first_name" form={formik} className="text-danger" />
                                        </div>
                                    </div>
                                    <div className='col-md-6'>
                                        <div className="mb-3">
                                            <label htmlFor='last_name' className="form-label">{t("restaurant.profile.label_last_name")}<span>*</span></label>
                                            <input
                                                type="text"
                                                id='last_name'
                                                className="form-control"
                                                placeholder={t("restaurant.profile.placeholder_last_name")}
                                                name='last_name'
                                                value={formik.values.last_name}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                            />
                                            <CustomError name="last_name" form={formik} className="text-danger" />
                                        </div>
                                    </div>
                                    <div className='col-md-6'>
                                        <div className="mb-3">
                                            <label htmlFor='email' className="form-label">{t("restaurant.profile.label_email_address")} <span>*</span></label>
                                            <input
                                                type="email"
                                                id='email'
                                                className="form-control"
                                                name='email'
                                                disabled
                                                value={formik.values.email}
                                            />
                                            <CustomError name="email" form={formik} className="text-danger" />
                                        </div>
                                    </div>
                                    <div className='col-md-6'>
                                        <div className="mb-3">
                                            <label htmlFor='phone_number' className="form-label">{t("restaurant.profile.label_phone_number")}<span>*</span></label>
                                            <PhoneInput
                                                value={formik?.values?.phone_number}
                                                name={'phone_number'} onChange={(e) => { formik.setFieldValue('phone_number', e?.phone_number) }} onBlur={formik.handleBlur} />
                                            <CustomError name="phone_number" form={formik} className="text-danger" shortCodes={{ PHONE_MIN_LENGTH: PHONE_NO_LENGTH.min, PHONE_MAX_LENGTH: PHONE_NO_LENGTH.max }} />
                                        </div>
                                    </div>
                                  
                                </div>
                                <div className='button-form'>
                                    <button className={"btn btn-primary " + (addSubmissionLoader ? " btn-loader" : "")}>{t("restaurant.profile.btn_update_profile")}</button>
                                </div>
                            </form>
                        }
                    </div>
                </div>
            </div>
        </main>
    )
}
